<template>
  <v-container fluid style="padding-right:0px; padding-bottom:0px">
    <copy-helpers :data="copy" :hotRef="hotRef" />
      <div class="hot">
        <hot-table :data="copy" :settings="hotSettings" ref="hotTableComponent" id="copy-table"/>
      </div>
  </v-container>
</template>

<script>
  import { HotTable } from '@handsontable/vue'
  // eslint-disable-next-line no-unused-vars
  import Handsontable from 'handsontable'
  import CopyHelpers from './CopyHelpers'
  import copyData from '../../../../static/dummy-data/sample-copy-gcs.json'

  export default {
    name: 'Copy',
    components: {
      HotTable,
      CopyHelpers
    },
    data () {
      return {
        hotSettings: {
          licenseKey: 'non-commercial-and-evaluation',
          nestedHeaders: [
            [
              // {label: '', colspan: 1},
              {label: 'Copy', colspan: 5},
              {label: 'Album', colspan: 2},
              {label: 'District', colspan: 2}
            ],
            ['ID', 'Ad Text', 'Headline', 'Description', 'CTA', 'Album', 'Topic', 'District', 'Candidate']
          ],
          columns: [
            {data: 'title'},
            {data: 'ad_text'},
            {data: 'ad_headline'},
            {data: 'ad_link_description'},
            {data: 'cta'},
            {data: 'album'},
            {data: 'topic'},
            {data: 'district',
              type: 'autocomplete',
              source: ['VA-HD-62', 'VA-HD-84', 'VA-HD-100'],
              strict: false
            },
            {data: 'candidate'}
          ],
          rowHeaders: true,
          width: '100%',
          stretchH: 'all',
          height: 560,
          colWidths: 110,
          // fixedColumnsLeft: 1,
          cells: function (row, col) {
            var cellProperties = {}

            if (col === 1) {
              cellProperties.colWidths = 200
            // } else if (col === 1) {
            //   cellProperties.colWidths = 150
            // } else if (col === 2) {
            //   cellProperties.colWidths = 200
            }

            return cellProperties
          },
          dropdownMenu: ['filter_by_value', 'filter_action_bar'],
          filters: true,
          headerTooltips: {
            columns: true,
            onlyTrimmed: true
          },
          hiddenColumns: {
            columns: [6, 7, 8],
            indicators: true
          },
          contextMenu: ['row_above', 'row_below', 'remove_row'],
          outsideClickDeselects: false,
          minSpareRows: 1
        },
        hotRef: {}
        // id: 'my-custom-id',
        // className: 'my-custom-classname',
        // style: 'width: 300px; height: 142px; overflow: hidden; border: 1px solid red;'
      }
    },
    computed: {
      copy () {
        return copyData
      }
    },
    methods: {
      // getTableData () {
      //   const hot = this.$refs.hotTableComponent.hotInstance
      //   // hot.loadData([['new', 'data']])
      //   console.log(hot.getData())
      //   console.log(hot.getSourceData())
      //   console.log(hot.getSourceDataAtRow(0))
      //   console.log(hot.getSelected())
      //   console.log(hot.getSelectedLast())
      //   console.log(hot.getSelectedRange())
      // }
    },
    mounted () {
      this.hotRef = this.$refs.hotTableComponent.hotInstance
    }
  }
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
